import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ITicketResponse } from '../ticket-response';
import { ticketResponseSchema } from '../ticket-response';
import type { IAdminReplyTicketRequest } from './admin-reply-ticket-request';

export async function adminReplyTicketApi(
  id: number,
  body: IAdminReplyTicketRequest,
): Promise<IValidatedResponse<ITicketResponse>> {
  return postRequest<ITicketResponse>({
    path: `/sys/ticket/${id}/reply`,
    body,
    schema: ticketResponseSchema,
  });
}
